import React, { useContext, useState } from 'react';
import { makeStyles } from '@material-ui/styles';
import styles from './MobilePhotoPicker.styles';
import { InspectorOrderReviewContext, UPDATE_IMAGES } from '../InspectorOrderReviewContext/InspectorOrderReviewContext';
import { saveUploadedImages } from '../../../services';
import PhotoCamera from '@material-ui/icons/PhotoCamera';
import { Button, CircularProgress, Dialog, DialogActions, DialogContent, Typography } from '@material-ui/core';
import ImageCarousel from '../../ImageCarousel';
import ArrowDownwardIcon from '@material-ui/icons/ArrowDownward';
import { AppContext } from '../../../AppContext';

const useStyles = makeStyles(styles);

const IMAGE_UPLOAD_INPUT_ID = 'field-rep-inspection-form-image-upload-input';

const MobilePhotoPicker = ({
  //
  question,
  answerTriggerIndex,
  imageRequired,
  images,
  onAddImage,
  imageIsAttached,
  removeImageFromQuestion,
  //
  iconStyle,
}) => {
  /**
   * STATE
   */
  const [imagesUploading, setImagesUploading] = useState(false);
  const [dialogOpen, setDialogOpen] = useState(false);

  /**
   * HOOKS
   */
  const classes = useStyles();

  const { state, dispatch } = useContext(AppContext);
  const {
    state: { isSelfInspect, order, orderForms, imagesWithQuestions },
    dispatch: reviewDispatch,
  } = useContext(InspectorOrderReviewContext);

  /**
   * FUNCTIONS
   */
  const openImageDialog = info => {
    setDialogOpen(true);
  };
  const closeImageDialog = () => {
    setDialogOpen(false);
  };

  const uploadPhotos = async (files, upload = true) => {
    // add new images to the misc images array
    // then save to the backend which will generate IDs for the images

    const tempOrderForms = JSON.parse(JSON.stringify(orderForms));

    // console.log(tempOrderForms);

    if (!tempOrderForms.length) {
      return console.log('no order forms to append to...');
    }

    // console.log({
    //   files,
    //   tempOrderForms,
    //   order,
    // });

    // return;
    // tempOrderForms[0].miscImages = tempOrderForms[0].miscImages ? tempOrderForms[0].miscImages.concat(...files) : files;

    try {
      setImagesUploading(true);

      let newImages = [];

      if (upload) {
        newImages = await saveUploadedImages(tempOrderForms, order.orderLineId, files);

        reviewDispatch({
          type: UPDATE_IMAGES,
          images: newImages,
        });
        dispatch({
          type: 'SET_SNACKBAR',
          snackbar: {
            isOpen: true,
            variant: 'success',
            message: 'Pictures uploaded successfully',
          },
        });
      } else {
        newImages = files;
      }

      setImagesUploading(false);

      newImages.length && onAddImage(newImages[0]);

      // get the image carousel and scroll to the beginning
      // const imageCarouselRef = document.getElementById('image-carousel-scrollview');
      // if (imageCarouselRef) {
      //   imageCarouselRef.scrollTo({ left: 0, behavior: 'smooth' });
      // }
      // messagesContainerRef.scrollTo({ top: messagesContainerRef.scrollHeight, behavior: 'smooth' });

      return;
    } catch (error) {
      console.log(error);

      dispatch({
        type: 'SET_SNACKBAR',
        snackbar: {
          isOpen: true,
          variant: 'error',
          message: 'An error occurred while uploading your images... Please try again',
        },
      });

      setImagesUploading(false);

      return;
    }
  };

  const createImageObjectFromFile = (file, fileIndex) => {
    const fileType = (file.name || file.src || file.imageUri).split('.').slice(-1);

    const imageUri = file.src ? file.src : URL.createObjectURL(file);

    return Object.assign(file, {
      imageUri,
      src: imageUri,
      fileName: `${new Date().getTime()}_${fileIndex}.${fileType}`,
      label: null,
    });
  };

  const onMediaAdded = () => {
    const media = Array.from(document.getElementById(IMAGE_UPLOAD_INPUT_ID).files)
      .map((file, fileIndex) => {
        return createImageObjectFromFile(file, fileIndex);
      })
      .filter(i => i); // get rid of any null values

    // console.log(media);

    // add images to the rest of the images
    // put the images first in case anything changed with a duplicated image but it keeps the same filename

    uploadPhotos(media);
  };

  return (
    <>
      <PhotoCamera
        onClick={() => {
          openImageDialog({
            // question,
            // answerTriggerIndex,
            // imageRequired,
            // images: filteredImages,
            // onAddImage: onDropImage,
          });
        }}
        style={iconStyle}
      />

      <Dialog
        //
        open={dialogOpen}
        onClose={closeImageDialog}
        fullWidth
      >
        {/* <DialogTitle>Images</DialogTitle> */}
        <DialogContent
          dividers
          style={{
            paddingTop: 20,
          }}
        >
          {!!question && (
            <>
              <section>
                <Typography variant="body1" className="mt-20 text-center">
                  All Photos
                </Typography>
                <>
                  <ImageCarousel
                    renderPlaceholder={'No photos available... Please upload more by clicking the button above'}
                    images={imagesWithQuestions.filter(
                      image => !imageIsAttached(question, image.src, question.answerTriggers?.[answerTriggerIndex]),
                    )}
                    containerStyle={{
                      border: '1px dotted gray',
                      borderRadius: 5,
                      // paddingLeft: 15,
                    }}
                    containerOffset={17}
                    onClick={(image, index) => {
                      const imageObject = createImageObjectFromFile(image);

                      uploadPhotos([imageObject], false);

                      dispatch({
                        type: 'SET_SNACKBAR',
                        snackbar: {
                          isOpen: true,
                          variant: 'success',
                          message: 'Image added!',
                        },
                      });
                    }}
                  />
                </>

                <div className="text-center my-20">
                  <Typography variant="subtitle2" className="text-center text-bold">
                    Click on photos above to attach them to the selected question
                  </Typography>
                  <ArrowDownwardIcon fontSize="40" />
                </div>

                <ImageCarousel
                  renderPlaceholder="No attached photos.  Add from the list above or upload more with the button below"
                  images={images}
                  containerStyle={{
                    border: '1px dotted gray',
                    borderRadius: 5,
                    // paddingLeft: 15,
                  }}
                  containerOffset={17}
                  onDelete={(image, imageIndex) => {
                    const updatedImages = images.slice(0, imageIndex).concat(images.slice(imageIndex + 1));

                    removeImageFromQuestion(question, image, answerTriggerIndex);
                  }}
                />

                {/* <Typography variant="body1" className="mt-20 text-center">
                    Photos for:
                  </Typography> */}
                <Typography variant="body1" className="text-center text-bold mt-10">
                  Attaching to: {question.question.value}
                  {!!answerTriggerIndex && (
                    <span className="text-hint">: {question.answerTriggers[answerTriggerIndex].value}</span>
                  )}
                </Typography>
              </section>

              <section className="mt-20 text-center">
                <input
                  type="file"
                  accept="image/jpeg"
                  // accept="image/*"
                  // accept="image/png, image/jpeg"
                  // accept=".png,.jpg,.jpeg,.m4v,.mp4,.mov,.3pg,.mkv"
                  // accept=".png,.jpg,.jpeg,.mp4,.ogg,.webm"
                  // multiple
                  id={IMAGE_UPLOAD_INPUT_ID}
                  name={IMAGE_UPLOAD_INPUT_ID}
                  className="hide"
                  onChange={onMediaAdded}
                  //
                />
                <label htmlFor={IMAGE_UPLOAD_INPUT_ID}>
                  <Button
                    variant="contained"
                    component="span"
                    className="blue-button"
                    style={{
                      textTransform: 'none',
                    }}
                  >
                    Upload/Capture Image
                  </Button>
                </label>

                {/* <Button
              variant="contained"
              onClick={evt => {
                evt.preventDefault();
                document.getElementById(IMAGE_UPLOAD_INPUT_ID).click();
              }}
              textClasses="ml-5 blue-button"
            >
              Browse...
            </Button> */}
              </section>
            </>
          )}
        </DialogContent>
        <DialogActions
          style={{
            flexDirection: 'row',
            justifyContent: 'center',
          }}
        >
          {/* Loading indicator */}
          {/* <div style={{ flex: 1, paddingLeft: 10, paddingRight: 10 }}>
              {isSubmitting && <LinearProgress />}
              {submitMessage && <div>{submitMessage}</div>}
            </div> */}

          {/* Confirmation Button */}
          <Button
            //
            onClick={closeImageDialog}
            variant="contained"
            className="blue-button"
            disabled={imagesUploading}
          >
            {imagesUploading ? <CircularProgress color="#fff" size={18} /> : 'Close'}
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
};

export default MobilePhotoPicker;
